import { useEffect, useRef, useState } from "react";
import { FaChevronDown, FaSpinner, FaUserCircle } from "react-icons/fa";
import { NavLink, useNavigate } from "react-router-dom";
import { menuItems } from "../../Assets/assests.js";
import axiosInstance from "../../utils/axios.js";
import UserLoginModal from "../user/Modal/UserLoginModal.jsx";

const BotBar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [services, setServices] = useState([]);

  const [campaignsLoading, setCampaignsLoading] = useState(true);
  const [servicesLoading, setServicesLoading] = useState(true);

  const getCampaignData = async () => {
    try {
      setCampaignsLoading(true);
      const response = await axiosInstance.get("/campaigns/all-campaigns");
      setCampaigns(response.data);
    } catch (error) {
      console.error("Error fetching campaigns for dropdown:", error);
    } finally {
      setCampaignsLoading(false);
    }
  };

  const specialCampaigns = campaigns.filter((c) => c.isSignificant);
  const featuredCampaigns = campaigns.filter((c) => !c.isSignificant);

  const getServiceData = async () => {
    try {
      setServicesLoading(true);
      const response = await axiosInstance.get("/services/all-services");
      setServices(response.data);
    } catch (error) {
      console.error("Error fetching services for dropdown:", error);
    } finally {
      setServicesLoading(false);
    }
  };

  useEffect(() => {
    getCampaignData();
    getServiceData();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Refs for dropdown management
  const dropdownTimeoutRef = useRef(null);
  const profileTimeoutRef = useRef(null);
  const navbarRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("ngo-afsa-token");
    setIsLoggedIn(!!token);
  }, [isLoginModalOpen]);

  const handleLogout = () => {
    localStorage.removeItem("ngo-afsa-token");
    localStorage.removeItem("ngo-afsa-data");
    setIsLoggedIn(false);
    setDropdownOpen(false);
    navigate("/");
  };

  const clearAllTimeouts = () => {
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
      dropdownTimeoutRef.current = null;
    }
    if (profileTimeoutRef.current) {
      clearTimeout(profileTimeoutRef.current);
      profileTimeoutRef.current = null;
    }
  };

  const handleDropdownEnter = (index) => {
    clearAllTimeouts();
    setActiveDropdown(index);
    setDropdownOpen(false);
  };

  const handleDropdownLeave = () => {
    clearAllTimeouts();
    dropdownTimeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 200);
  };

  const handleDropdownClick = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
    setDropdownOpen(false);
  };

  const handleProfileEnter = () => {
    clearAllTimeouts();
    setDropdownOpen(true);
    setActiveDropdown(null);
  };

  const handleProfileLeave = () => {
    clearAllTimeouts();
    profileTimeoutRef.current = setTimeout(() => {
      setDropdownOpen(false);
    }, 200);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      clearAllTimeouts();
    };
  }, []);

  return (
    <div>
      <nav
        ref={navbarRef}
        className="hidden lg:flex justify-center bg-[#02323F] w-full px-4 sm:px-6 lg:px-8 shadow-[0px_2px_4px_0px_rgba(141,141,141,0.15)] relative"
      >
        <div className="flex w-full  items-center justify-center  lg:space-x-2 xl:space-x-3 relative">
          {menuItems.map((item, index) => {
            const IconComponent = item.icon;

            return (
              <div
                key={index}
                className="relative"
                onMouseEnter={() =>
                  item.hasDropdown && handleDropdownEnter(index)
                }
                onMouseLeave={() => item.hasDropdown && handleDropdownLeave()}
              >
                {item.hasDropdown ? (
                  <NavLink
                    to={item.path}
                    onClick={() => {
                      clearAllTimeouts();
                      setActiveDropdown(null);
                      setDropdownOpen(false);
                    }}
                    className={`flex items-center space-x-1 whitespace-nowrap hover:bg-[#FCC101]/20 hover:text-white text-sm sm:text-[0.9rem] md:text-base lg:text-sm font-medium px-1 xl:px-3 py-3 transition-all duration-200 group ${
                      activeDropdown === index
                        ? "text-[#FCC101] border-b-2 border-[#FCC101]"
                        : "text-white"
                    }`}
                  >
                    {item.icon && <IconComponent className="w-4 h-4" />}
                    <span className="text-sm xl:text-base">{item.title}</span>
                    <FaChevronDown
                      className={`text-xs transition-transform duration-200 ${
                        activeDropdown === index ? "rotate-180" : ""
                      }`}
                    />
                  </NavLink>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center space-x-1 whitespace-nowrap hover:bg-[#FCC101]/20 hover:text-white text-sm sm:text-[0.9rem] md:text-base  font-medium px-3 lg:px-2 xl:px-3 py-3 transition-all duration-200 group ${
                        isActive
                          ? "text-[#FCC101] border-b-2 border-[#FCC101]"
                          : "text-white"
                      }`
                    }
                    onClick={() => {
                      clearAllTimeouts();
                      setActiveDropdown(null);
                      setDropdownOpen(false);
                    }}
                  >
                    {item.icon && <IconComponent className="w-4 h-4" />}
                    <span className="text-sm xl:text-base">{item.title}</span>
                  </NavLink>
                )}

                {item.hasDropdown && activeDropdown === index && (
                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-64 max-w-sm z-[9999]">
                    <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white/90 backdrop-blur-md rotate-45 border-l border-t border-gray-200"></div>
                    <div
                      className="bg-white/90 backdrop-blur-md rounded-xl shadow-2xl border border-gray-200 py-2 mt-2 max-h-64 overflow-y-auto transition-all duration-300  hide-scrollbar
                    "
                    >
                      {item.title === "Campaigns" ? (
                        campaignsLoading ? (
                          <div className="flex items-center justify-center py-6 text-gray-500">
                            <FaSpinner className="animate-spin mr-2" />{" "}
                            Loading...
                          </div>
                        ) : (
                          <>
                            {/* Special Campaigns */}
                            {specialCampaigns.length > 0 && (
                              <>
                                <div className="px-3 py-1 text-[10px] tracking-wide font-semibold text-[#02323F] uppercase">
                                  Special Campaigns
                                </div>
                                {specialCampaigns.map((campaign) => (
                                  <NavLink
                                    key={campaign._id}
                                    to={`/campaigns/${campaign._id}`}
                                    target="_blank"
                                    className="block px-6 py-2 hover:bg-[#FCC101]/10 transition-colors group"
                                    onClick={() => {
                                      clearAllTimeouts();
                                      setActiveDropdown(null);
                                      setDropdownOpen(false);
                                    }}
                                  >
                                    <span className="font-medium text-xs truncate line-clamp-1 text-gray-800 group-hover:text-[#02323F]">
                                      {campaign.name}
                                    </span>
                                  </NavLink>
                                ))}
                              </>
                            )}

                            {/* Featured Campaigns */}
                            {featuredCampaigns.length > 0 && (
                              <>
                                <div className="px-3 py-1 text-[10px] tracking-wide font-semibold text-[#02323F] uppercase mt-2">
                                  Featured Campaigns
                                </div>
                                {featuredCampaigns.map((campaign) => (
                                  <NavLink
                                    key={campaign._id}
                                    to={`/campaigns/${campaign._id}`}
                                    target="_blank"
                                    className="block px-6 py-2 hover:bg-[#FCC101]/10 transition-colors group"
                                    onClick={() => {
                                      clearAllTimeouts();
                                      setActiveDropdown(null);
                                      setDropdownOpen(false);
                                    }}
                                  >
                                    <span className="font-medium text-xs truncate line-clamp-1 text-gray-800 group-hover:text-[#02323F]">
                                      {campaign.name}
                                    </span>
                                  </NavLink>
                                ))}
                              </>
                            )}
                          </>
                        )
                      ) : item.title === "Our Work" ? (
                        servicesLoading ? (
                          <div className="flex items-center justify-center py-6 text-gray-500">
                            <FaSpinner className="animate-spin mr-2" />{" "}
                            Loading...
                          </div>
                        ) : (
                          services?.map((service) => (
                            <NavLink
                              key={service._id}
                              to={`/services/${service._id}`}
                              target="_blank"
                              className="block px-6 py-2 hover:bg-[#FCC101]/10 transition-colors group"
                              onClick={() => {
                                clearAllTimeouts();
                                setActiveDropdown(null);
                                setDropdownOpen(false);
                              }}
                            >
                              <span className="font-medium text-sm truncate text-gray-800 group-hover:text-[#02323F] transition-colors">
                                {service.serviceName}
                              </span>
                            </NavLink>
                          ))
                        )
                      ) : (
                        item.dropdown.map((dropdownItem, dropdownIndex) => (
                          <NavLink
                            key={dropdownIndex}
                            to={dropdownItem.path}
                            target="_blank"
                            className="block px-6 py-2 hover:bg-[#FCC101]/10 transition-colors group"
                            onClick={() => {
                              clearAllTimeouts();
                              setActiveDropdown(null);
                              setDropdownOpen(false);
                            }}
                          >
                            <span className="font-medium text-sm truncate text-gray-800 group-hover:text-[#02323F] transition-colors">
                              {dropdownItem.title}
                            </span>
                          </NavLink>
                        ))
                      )}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {/* Profile/Login Section */}
        <div
          ref={profileRef}
          className="relative flex items-center justify-center"
          onMouseEnter={isLoggedIn ? handleProfileEnter : undefined}
          onMouseLeave={isLoggedIn ? handleProfileLeave : undefined}
        >
          {isLoggedIn ? (
            <>
              <button
                onClick={() => {
                  clearAllTimeouts();
                  setDropdownOpen((prev) => !prev);
                  setActiveDropdown(null);
                }}
                className="text-white text-2xl flex items-center justify-center hover:text-[#FCC101] transition-colors duration-200"
                title="Profile"
              >
                <FaUserCircle />
              </button>

              {dropdownOpen && (
                <div className="absolute right-0 top-full z-[9999]">
                  <div className="absolute right-[0.4rem] top-0.5 w-4 h-4 bg-white/90 backdrop-blur-md rotate-45 border-l border-t border-gray-200"></div>
                  <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-2xl border border-gray-200 mt-2 w-40">
                    <ul className="py-1">
                      <li
                        className="px-4 py-2 hover:bg-[#FCC101]/10 cursor-pointer transition-colors duration-150 text-gray-800 hover:text-[#02323F]"
                        onClick={() => {
                          clearAllTimeouts();
                          navigate(`/profile`);
                        }}
                      >
                        Profile
                      </li>
                      <li
                        className="px-4 py-2 hover:bg-[#FCC101]/10 cursor-pointer transition-colors duration-150 text-gray-800 hover:text-[#02323F]"
                        onClick={handleLogout}
                      >
                        Logout
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </>
          ) : (
            <button
              onClick={() => setIsLoginModalOpen(true)}
              className={
                "rounded-full hover:bg-[#FCC101] font-poppins font-medium  align-middle text-white hover:text-black px-4 md:px-6 py-2 md:py-3 transition-all duration-200 ease-in-out active:scale-[101%] text-sm xl:text-base"
              }
            >
              LOGIN{" "}
            </button>
          )}
        </div>
      </nav>

      <UserLoginModal
        isOpen={isLoginModalOpen}
        setIsOpen={setIsLoginModalOpen}
      />
    </div>
  );
};

export default BotBar;

// {
//   item.hasDropdown && activeDropdown === index && (
//     <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-64 max-w-sm z-[9999]">
//       <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white/90 backdrop-blur-md rotate-45 border-l border-t border-gray-200"></div>
//       <div className="bg-white/90 backdrop-blur-md rounded-xl shadow-2xl border border-gray-200 py-2 mt-2 max-h-64 overflow-y-auto transition-all duration-300">
//         {item.title === "Campaigns" ? (
//           campaignsLoading ? (
//             <div className="flex items-center justify-center py-6 text-gray-500">
//               <FaSpinner className="animate-spin mr-2" /> Loading...
//             </div>
//           ) : (
//             campaigns?.map((campaign) => (
//               <NavLink
//                 key={campaign._id}
//                 to={`/campaigns/${campaign._id}`}
//                 target="_blank"
//                 className="block px-6 py-3 hover:bg-[#FCC101]/10 transition-colors group"
//                 onClick={() => {
//                   clearAllTimeouts();
//                   setActiveDropdown(null);
//                   setDropdownOpen(false);
//                 }}
//               >
//                 <span className="font-medium text-sm truncate text-gray-800 group-hover:text-[#02323F] transition-colors w-full block">
//                   {campaign.name}
//                 </span>
//               </NavLink>
//             ))
//           )
//         ) : item.title === "Our Work" ? (
//           servicesLoading ? (
//             <div className="flex items-center justify-center py-6 text-gray-500">
//               <FaSpinner className="animate-spin mr-2" /> Loading...
//             </div>
//           ) : (
//             services.slice(0, 5).map((service) => (
//               <NavLink
//                 key={service._id}
//                 to={`/services/${service._id}`}
//                 target="_blank"
//                 className="block px-6 py-2 hover:bg-[#FCC101]/10 transition-colors group"
//                 onClick={() => {
//                   clearAllTimeouts();
//                   setActiveDropdown(null);
//                   setDropdownOpen(false);
//                 }}
//               >
//                 <span className="font-medium text-sm truncate text-gray-800 group-hover:text-[#02323F] transition-colors">
//                   {service.serviceName}
//                 </span>
//               </NavLink>
//             ))
//           )
//         ) : (
//           item.dropdown.map((dropdownItem, dropdownIndex) => (
//             <NavLink
//               key={dropdownIndex}
//               to={dropdownItem.path}
//               target="_blank"
//               className="block px-6 py-2 hover:bg-[#FCC101]/10 transition-colors group"
//               onClick={() => {
//                 clearAllTimeouts();
//                 setActiveDropdown(null);
//                 setDropdownOpen(false);
//               }}
//             >
//               <span className="font-medium text-sm truncate text-gray-800 group-hover:text-[#02323F] transition-colors">
//                 {dropdownItem.title}
//               </span>
//             </NavLink>
//           ))
//         )}
//       </div>
//     </div>
//   );
// }
